import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './style.css';

class SnackBar extends PureComponent {
  render() {
    const { show, message } = this.props.snackBar;
    return (
      <div className={`snackbar ${show ? 'show' : 'hide'}`} style={{ zIndex: 200 }}>
        {message}
      </div>
    );
  }
}

const mapStateToProps = ({ snackBar }) => ({
  snackBar,
});

export default connect(mapStateToProps)(SnackBar);
